// src/stone/icons/BoxGift.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var BoxGift = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 41 40",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          d: "M7.167 19a1 1 0 0 1 1 1v15.667h24.666V20a1 1 0 1 1 2 0v16.667a1 1 0 0 1-1 1H7.167a1 1 0 0 1-1-1V20a1 1 0 0 1 1-1"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          d: "M2.834 11.667a1 1 0 0 1 1-1h33.333a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1H3.834a1 1 0 0 1-1-1zm2 1V19h31.333v-6.333z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          d: "M20.5 10.667a1 1 0 0 1 1 1v25a1 1 0 0 1-2 0v-25a1 1 0 0 1 1-1"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          d: "M13 4.333a3.167 3.167 0 1 0 0 6.334h6.195a15 15 0 0 0-1.134-2.685c-1.087-1.977-2.7-3.649-5.06-3.649m7.5 7.334.98-.197v-.004l-.002-.007-.004-.023-.018-.081-.069-.289c-.061-.245-.154-.59-.285-1.003a17 17 0 0 0-1.288-3.045C18.61 4.828 16.473 2.333 13 2.333a5.167 5.167 0 1 0 0 10.334h7.5a1 1 0 0 0 .98-1.197z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          d: "M21.186 7.018c1.205-2.19 3.341-4.685 6.814-4.685a5.167 5.167 0 1 1 0 10.334h-7.5a1 1 0 0 1-.98-1.197l.98.197-.98-.197v-.004l.002-.007.005-.023.017-.081q.022-.104.069-.289c.061-.245.154-.59.285-1.003.26-.822.675-1.93 1.288-3.045m.619 3.649H28a3.167 3.167 0 1 0 0-6.334c-2.36 0-3.974 1.672-5.061 3.649a15 15 0 0 0-1.134 2.685"
        }
      )
    ]
  }
);
var BoxGift_default = BoxGift;

export {
  BoxGift,
  BoxGift_default
};
